import enLocale from 'element-ui/lib/locale/lang/en';
import zhLocale from 'element-ui/lib/locale/lang/zh-CN';

import directives_mousewheel from 'element-ui/lib/directives/mousewheel';
import directives_repeatClick from 'element-ui/lib/directives/repeat-click';

import mixins_emitter from 'element-ui/lib/mixins/emitter';
import mixins_focus from 'element-ui/lib/mixins/focus';
import mixins_locale from 'element-ui/lib/mixins/locale';
import mixins_migrating from 'element-ui/lib/mixins/migrating';

import transitions_collapseTransition from 'element-ui/lib/transitions/collapse-transition';

import utils_menu_ariaMenubar from 'element-ui/lib/utils/menu/aria-menubar';
import utils_menu_ariaMenuitem from 'element-ui/lib/utils/menu/aria-menuitem';
import utils_menu_ariaSubmenu from 'element-ui/lib/utils/menu/aria-submenu';

import utils_popup_index from 'element-ui/lib/utils/popup/index';
import utils_popup_popupManager from 'element-ui/lib/utils/popup/popup-manager';

import utils_afterLeave from 'element-ui/lib/utils/after-leave';
import utils_ariaDialog from 'element-ui/lib/utils/aria-dialog';
import utils_ariaUtils from 'element-ui/lib/utils/aria-utils';
import utils_clickoutside from 'element-ui/lib/utils/clickoutside';
import * as utils_dateUtil from 'element-ui/lib/utils/date-util';
import * as utils_date from 'element-ui/lib/utils/date';
import * as utils_dom from 'element-ui/lib/utils/dom';
import utils_merge from 'element-ui/lib/utils/merge';
import * as utils_popper from 'element-ui/lib/utils/popper';
import * as utils_resizeEvent from 'element-ui/lib/utils/resize-event';
import utils_scrollIntoView from 'element-ui/lib/utils/scroll-into-view';
import utils_scrollbarWidth from 'element-ui/lib/utils/scrollbar-width';
import * as utils_shared from 'element-ui/lib/utils/shared';
import * as utils_types from 'element-ui/lib/utils/types';
import * as utils_util from 'element-ui/lib/utils/util';
import * as utils_vdom from 'element-ui/lib/utils/vdom';
import utils_vuePopper from 'element-ui/lib/utils/vue-popper';

const libs = {
  directives_mousewheel,
  directives_repeatClick,
  mixins_emitter,
  mixins_focus,
  mixins_locale,
  mixins_migrating,
  transitions_collapseTransition,
  utils_menu_ariaMenubar,
  utils_menu_ariaMenuitem,
  utils_menu_ariaSubmenu,
  utils_popup_index,
  utils_popup_popupManager,
  utils_afterLeave,
  utils_ariaDialog,
  utils_ariaUtils,
  utils_clickoutside,
  utils_dateUtil,
  utils_date,
  utils_dom,
  utils_merge,
  utils_popper,
  utils_resizeEvent,
  utils_scrollIntoView,
  utils_scrollbarWidth,
  utils_shared,
  utils_types,
  utils_util,
  utils_vdom,
  utils_vuePopper
};

/** ********* 修改popper方法，以便popper弹出窗能跟随多层滚动div begin ***********/
function getStyleComputedProperty (element, property) {
  // NOTE: 1 DOM access here
  var css = getComputedStyle(element, null);
  return css[property];
}

function getScrollParent (element, targets) {
  var parent = element.parentNode;
  const root = window;
  if (!parent) {
    targets.push(element);
    return;
  }

  if (parent === root.document) {
    if (root.document.body.scrollTop || root.document.body.scrollLeft) {
      targets.push(root.document.body);
      return;
    } else {
      targets.push(root.document.documentElement);
      return;
    }
  }
  if (['scroll', 'auto'].indexOf(getStyleComputedProperty(parent, 'overflow')) !== -1 || ['scroll', 'auto'].indexOf(getStyleComputedProperty(parent, 'overflow-x')) !== -1 || ['scroll', 'auto'].indexOf(getStyleComputedProperty(parent, 'overflow-y')) !== -1) {
    targets.push(parent);
  }
  return getScrollParent(element.parentNode, targets);
}

utils_popper.prototype._setupEventListeners = function () {
  this.state.updateBound = this.update.bind(this);
  const root = window;
  root.addEventListener('resize', this.state.updateBound);
  if (this._options.boundariesElement !== 'window') {
    var targets = [];
    getScrollParent(this._reference, targets);

    if (targets.length > 0) {
      targets = targets.map(el => {
        if (el === root.document.body || el === root.document.documentElement) {
          return root;
        }
        return el;
      });

      targets.forEach(el => {
        el.addEventListener('scroll', this.state.updateBound);
      });
    }
    this.state.scrollTargets = targets;
  }
};

utils_popper.prototype._removeEventListeners = function () {
  const root = window;
  root.removeEventListener('resize', this.state.updateBound);
  if (this._options.boundariesElement !== 'window' && this.state.scrollTargets.length > 0) {
    this.state.scrollTargets.forEach(el => {
      el.removeEventListener('scroll', this.state.updateBound);
    });
    this.state.scrollTargets = [];
  }
  this.state.updateBound = null;
};
/** ********* 修改popper方法，以便popper弹出窗能跟随多层滚动div end ***********/

const ElementLibs = {};

Object.assign(ElementLibs, {
  ...libs,

  // 将连接符转换为对象形式
  ...Object.keys(libs).reduce((res, key) => {
    let tmp = res;
    key.split('_').forEach((attr, index, array) => {
      if (index < array.length - 1) {
        tmp[attr] = tmp[attr] || {};
        tmp = tmp[attr];
      } else {
        tmp[attr] = libs[key];
      }
    })

    return res;
  }, {})
});

const lang = {
  en: enLocale,
  zhCN: zhLocale
};

export { ElementLibs, lang };



// WEBPACK FOOTER //
// ./~/vue-xpc/src/element.js